module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAYAAACcuBHKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD8SURBVHgB7ZXhDcIgEIWvTtAR6iZuoG7QETpCR9AJGicwTsAIHYFuQDdAiNf0BcUSA/wwfMkl9HiBgzuuRIVCoZAArXVjbDA2GhPGWsoJB6D0Ox3lgm9gQcJYUQ7MRjXcgmSfgEAOlBqbe9iwZd8BfIJSA6eW9lbYVzs1UlMquCAXBmfuAnM9pcIuDhs1zhymZKRU6PUlCM+8+LVAdyEiXrThz5tH9oDxiWKj194gv2iwQFX0AoXFuw3dHVIS3EGD0mFYTjVv6K4wPlIgVYhIv1qyDWRiczlXVTU7Wsve+CeKgfM8P9F5tD3FhBuS8gQhQIdNLc9PrVAo/D1P1yajxVU5r2wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/Alieicon-White.png
// module id = 3690
// module chunks = 0